module.exports = __webpack_public_path__ + "img/data.da9639f3.svg";